import React, { useEffect } from 'react';
import styles from './SharedGraphs.module.css';
import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { useDispatch, useSelector } from 'react-redux';
import { getSensorDataFromTimePreset } from '../../api/metricsService';
import { rechartsDataFromMetrics } from '../../utils/chartUtils';
import { useTranslation } from 'react-i18next';
import CenteredSpinner from '../Shared/CenteredSpinner';

function SensorsGraph({
  systemId,
  sensors,
  sensorToGraph,
  height,
  toDate,
  fromDate,
  timePreset,
  showDots,
  yMin = 'dataMin',
  yMax = 'dataMax'
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const sensorMetrics = useSelector((state) => state.metricsReducer.sensors);

  useEffect(() => {
    sensors.forEach((sensor) => {
      sensor.ids.forEach((id) => {
        dispatch(
          getSensorDataFromTimePreset(
            systemId,
            id,
            timePreset,
            fromDate,
            toDate
          )
        );
      });
    });
  }, [sensors, timePreset, toDate, fromDate, systemId, sensorToGraph]);

  const metricsArrays = [];
  let loading = false;
  let error = false;
  sensors
    .filter((sensor) => sensor.name === sensorToGraph.name)
    .forEach((sensor) => {
      sensor.ids.forEach((id) => {
        if (sensorMetrics[id] && sensorMetrics[id][timePreset.name]) {
          const metricsInfo = sensorMetrics[id][timePreset.name];
          metricsArrays.push(metricsInfo.metrics);
          loading = loading || metricsInfo.loading;
          error = error || metricsInfo.error;
        }
      });
    });

  if (loading) {
    return (
      <div style={{ height: height }}>
        <CenteredSpinner />
      </div>
    );
  } else if (error) {
    return (
      <div style={{ height: height }}>
        <h3 className={styles.errorText}>{t('failure')}</h3>
      </div>
    );
  }

  const data = rechartsDataFromMetrics(metricsArrays, fromDate, toDate, t('h'));
  return data.length > 0 ? (
    <div
      className={styles.sensorGraphChartContainer}
      style={{ height: height }}
    >
      <ResponsiveContainer height={'100%'}>
        <LineChart data={data} width={'100%'}>
          <XAxis dataKey="name" />
          <YAxis
            unit={sensorToGraph.unit}
            domain={[yMin, yMax]}
            tickCount={10}
            tickFormatter={(value) => Math.round(value * 100) / 100}
          />
          <Tooltip />
          {sensors
            .find((sensor) => sensor.name === sensorToGraph.name)
            .ids.map((id) => (
              <Line
                dot={showDots}
                isAnimationActive={false}
                type={'monotone'}
                connectNulls={true}
                key={id.toString()}
                dataKey={id}
                stroke="#8884d8"
              />
            ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  ) : (
    <div className={styles.noDataContainer} style={{ height: height }}>
      {t('noDataReceived')}
    </div>
  );
}

export default SensorsGraph;
